/**
 * Compute weekday prayer flags.
 *
 * @param {import('@hebcal/core').HDate} hdate
 * @param {object} calData - from calendarProvider
 * @param {object} tachanun - from tachanunRules
 * @param {string} edah
 * @returns {object}
 */
export function computeWeekdayPrayers(hdate, calData, tachanun, edah) {
  const m = hdate.getMonth();
  const d = hdate.getDate();
  const dow = hdate.getDay(); // 0=Sun, 6=Sat

  // ═══ Kel Erech Apayim ═══
  // Mon/Thu only, follows tachanun rules
  const isMonThu = dow === 1 || dow === 4;
  const kelErechApayim = isMonThu && tachanun.shacharit;

  // ═══ Avinu Malkeinu ═══
  // Aseret Yemei Teshuvah (1-10 Tishrei) + fast days
  let avinuMalkeinu = { applicable: false, reason: null, skippedForShabbat: false };

  const isAYT = m === 7 && d >= 1 && d <= 10;

  if (isAYT) {
    if (calData.isShabbat) {
      // Ashkenaz: skip on Shabbat. Sephardim: may say it.
      avinuMalkeinu = {
        applicable: edah !== 'ashkenaz',
        reason: 'עשי״ת',
        skippedForShabbat: edah === 'ashkenaz',
      };
    } else {
      avinuMalkeinu = { applicable: true, reason: 'עשי״ת', skippedForShabbat: false };
    }
  } else if (calData.isFastDay) {
    // On fast days — Ashkenaz says it, Sephardim only during AYT
    if (edah === 'ashkenaz') {
      avinuMalkeinu = { applicable: true, reason: 'תענית', skippedForShabbat: false };
    }
    // Sephardic: don't say on regular fast days outside AYT
  }

  return {
    kelErechApayim,
    avinuMalkeinu,
  };
}
